import React from 'react';

import styled from 'styled-components';

import { Button } from 'components/Button';

import { StyledTextField } from 'components/Input/styles';

import CustomModal from 'components/CustomModal';

export const InfoText = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const HelpText = styled(InfoText)`
  margin-top: 24px;
  margin-bottom: 12px;
`;

const CONFIRMATION_TEXT = 'DELETE';

const DeleteEntityModal: React.FC<{
  onClose: () => void;
  handleRemove: () => void;
}> = ({ onClose, handleRemove }): React.ReactElement => {
  const [openModal, setOpenModal] = React.useState(true);
  const [confirmationText, setConfirmationText] = React.useState('');

  const onCloseModal = (): void => {
    setOpenModal(false);
    onClose();
  };

  const onDelete = (): void => {
    handleRemove();
    onCloseModal();
  };

  return (
    <CustomModal
      openModal={openModal}
      onClose={onCloseModal}
      modalTitle="Delete Pipeline"
      cancelButton={
        <Button
          id="cancel-action-button"
          data-testid="cancel-action-button"
          onClick={onCloseModal}
          variant="outlined"
          size="large"
        >
          Cancel
        </Button>
      }
      submitButton={
        <Button
          id="delete-action-button"
          data-testid="delete-action-button"
          onClick={onDelete}
          disabled={confirmationText !== CONFIRMATION_TEXT}
          variant="contained"
          size="large"
          color="error"
        >
          Delete
        </Button>
      }
    >
      <InfoText>Are you sure you want to delete this pipeline?</InfoText>
      <InfoText>Once removed, you will not be able to recover this data.</InfoText>
      <HelpText>
        Please type in <b>DELETE</b> to confirm
      </HelpText>
      <StyledTextField
        variant="outlined"
        placeholder="Please type in DELETE to confirm"
        value={confirmationText}
        onChange={(e) => {
          setConfirmationText(e.target.value);
        }}
      />
    </CustomModal>
  );
};

export default DeleteEntityModal;
